<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxLeave } from '@utils/message-box'
import { notification } from '@utils/notification'

export default {
  page: {
    title: '新增項目',
    meta: [{ name: 'description', content: 'Add Product' }],
  },
  components: {
    Layout,
    BaseSteps: () => lazyLoadComponent(import('@components/BaseSteps')),
    Step1Basic: () => lazyLoadComponent(import('./components/Step1Basic')), // 基本資訊
    ScheduleSet: () => lazyLoadComponent(import('./components/ScheduleSet')), // 行程設定
    EnvironmentIntro: () => lazyLoadComponent(import('./components/EnvironmentIntro')), // 環境介紹
    Step9SocialInfo: () => lazyLoadComponent(import('./components/Step9SocialInfo')), //  社群資料
    Step6ServiceTime: () => lazyLoadComponent(import('./components/Step6ServiceTime')), // 營業時間
    Step4ExtraField: () => lazyLoadComponent(import('./components/Step4ExtraField')), // 自訂題目
    Step8StoreImg: () => lazyLoadComponent(import('./components/Step8StoreImg')), // 商店圖片
  },
  props: {
    defaultStep: {
      type: Number,
      required: true,
    },
    productType: {
      type: String,
      default: 'service',
    },
    defaultValue: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      tryingNextStep: false,
      nextStepButtonVisible: false,
      activeStep: this.defaultStep,
      stepList: [
        {
          title: '基本資訊',
          description: '設定分店資訊',
        },
        {
          title: '社群資料',
          description: '設定社群資料',
        },
        {
          title: '營業時間',
          description: '設定營業時間',
        },
        {
          title: '自訂問題',
          description: '想知道客戶是如何得知你們的嗎？或是需要統計餐點數量提前做準備嗎？可以自訂問題與客戶互動喔～完成或想略過額外欄位新增請按下一步。',
        },
        {
          title: '設定圖片',
          description: '設定商店圖片',
        },
      ],
      formDataAll: {},
      tryingUpdateState: false,
      geocoder: '',
      map: [],
      hasGeo: false,
      basicSubmitData: {},
      socialSubmitData: {},
      serviceTimeSubmitData: {},
      relatedQSubmitData: {},
      imagesSubmitData: {},
      stepComponent: {}
    }
  },
  created() {
    if (this.$appType() === 'dingbeauty' && false) {
      this.stepList.splice(1, 0, {
        title: '行程設定',
        description: '設定行程設定',
      })
      this.stepList.splice(2, 0, {
        title: '環境介紹',
        description: '設定環境介紹',
      })
    }
  },
  computed: {
    productId() {
      return this.$route.params.productId
    },
  },
  mounted() {
    this.initGeocoder();
    this.initStepComponent()
  },
  methods: {
    /**
     * @description 初始化component列表
     */
    initStepComponent() {
      if (this.$appType() === 'ipetbooking') {
        this.stepComponent = {
          'step1': 'Step1Basic', // 基本資訊
          'step2': 'Step9SocialInfo', //  社群資料
          'step3': 'Step6ServiceTime', // 營業時間
          'step4': 'Step4ExtraField', // 自訂題目
          'step5': 'Step8StoreImg', // 商店圖片
        }
      }
      if (this.$appType() === 'dingbeauty') {
        this.stepComponent = {
          'step1': 'Step1Basic', // 基本資訊
          // 'step2': 'ScheduleSet', // 行程設定
          // 'step3': 'EnvironmentIntro', // 環境介紹
          'step2': 'Step9SocialInfo', //  社群資料
          'step3': 'Step6ServiceTime', // 營業時間
          'step4': 'Step4ExtraField', // 自訂題目
          'step5': 'Step8StoreImg', // 商店圖片
        }
      }
    },
    handleFormValidate(valid) {
      this.nextStepButtonVisible = valid
    },
    async onClickLeave() {
      try {
        await messageBoxLeave('分店')
        this.$router.push({ name: 'products' })
      }
      catch (error) {

      } finally {

      }
    },
    handleStorePrice(storeData) {
      return this.$store.dispatch('product/storePrices', {
        productId: this.productId,
        storeData,
      })
    },
    handleStoreInventory(submitData) {
      return this.$store.dispatch('inventory/storeGroups', {
        productId: this.productId,
        submitData,
      })
    },
    async handleStoreProduct(submitData) {
      await this.geocode(submitData)
      submitData.lat = this.map[0]
      submitData.lng = this.map[1]
      const storeData = {
        ...submitData,
        type: this.productType,
        staffs: submitData.staffs.map((staff) => {
          return {
            id: staff.id,
            hostTitle: staff.hostTitle,
          }
        }),
      }
      return this.$store.dispatch('product/store', storeData)
    },
    /**
     * @description 自訂問題API
     */
    handleStoreExtraField(submitData, newProduct) {
      const extraFields = [...submitData.byOrder, ...submitData.bySize]
      const storeData = {
        productId: newProduct.id,
      }
      extraFields.forEach(item => {
        item.id = ''
        item.productId = newProduct.id
      })
      if (extraFields.length > 0) storeData.extraFields = extraFields
      return this.$store.dispatch('product/updateExtraField', storeData)
    },
    incrementActiveStep() {
      if (this.activeStep++ === this.stepList.length) this.activeStep = 1
      this.tryingNextStep = false
    },
    async onClickNextStep() {
      try {
        const componentText = this.stepComponent[`step${this.activeStep}`]
        switch (componentText) {
          case 'Step1Basic': // 基本資訊
            await this.$refs.step.validate()
            this.formDataAll = this.$refs.step.formatSubmitData
            this.basicSubmitData = this.$refs.step.formatSubmitData
            this.activeStep++
            this.tryingNextStep = false
            break
          case 'ScheduleSet': // 行程設定
            this.activeStep++
            this.tryingNextStep = false
            break
          case 'EnvironmentIntro': // 環境介紹
            this.tryingNextStep = false
            this.activeStep++
            break
          case 'Step9SocialInfo': // 社群資料
            this.socialSubmitData = this.$refs.step.submitData
            this.activeStep++
            break
          case 'Step6ServiceTime': // 營業時間
            await this.$refs.step.validate()
            if (!this.$refs.step.validateBySelf()) {
              this.tryingToSave = false
              return
            }
            this.tryingNextStep = true
            const timeData = this.$refs.step.serviceTimeSetting
            for (let i in timeData) {
              timeData[i].start = timeData[i].timeRange[0]
              timeData[i].end = timeData[i].timeRange[1]
            }
            this.serviceTimeSubmitData = this.$refs.step.serviceTimeSetting
            this.activeStep++
            this.tryingNextStep = false
            break
          case 'Step4ExtraField': // 自訂問題
            const list = this.$refs.step.list
            this.relatedQSubmitData = list
            this.activeStep++
            break
          case 'Step8StoreImg': // 相關圖片
            this.tryingNextStep = true
            this.imagesSubmitData = this.$refs.step.submitData // 只會回傳images給這邊
            this.setFirstImageDefault()
            const newProduct = await this.handleStoreProduct({
              ...this.basicSubmitData,
              ...this.socialSubmitData,
              ...this.imagesSubmitData,
              serviceTimeSetting: this.serviceTimeSubmitData
            })
            await this.handleStoreExtraField(this.relatedQSubmitData, newProduct)
            messageStore('add')
            notification('分店資訊', '分類設定', 'prices?tab=category')
            this.$router.push({ name: 'products' })
            this.tryingNextStep = false
            break
        }
      } catch (error) {
        this.tryingNextStep = false
      }
    },
    setFirstImageDefault() {
      try {
        const { images } = this.imagesSubmitData
        images.forEach((item, index) => {
          item.default = index === 0 ? 1 : 0
        })
      } catch (error) {
        console.error(error.message)
      }
    },
    async updateItemState(state = 1) {
      this.tryingUpdateState = true
      try {
        await this.$store.dispatch('product/updateState', {
          ids: [this.productId],
          state,
        })
        this.$router.push({ name: 'products' })
        this.tryingUpdateState = false
      } catch (error) {
        this.tryingUpdateState = false
      }
    },
    initGeocoder() {
      this.geocoder = new google.maps.Geocoder();
    },
    async geocode(submitData) {
      // const address = this.restaurant.address;
      const callback = await this.geocoder.geocode(
        // GeocoderRequest 物件: 帶入要轉換的地址與相關設定
        {
          address: `${submitData.location.city}${submitData.location.district}${submitData.location.address}`,
          // 限制轉換的結果必須是在台灣的範圍
          componentRestrictions: {
            country: "TW"
          }
        }
      );
      const lat = callback.results[0].geometry.location.lat()
      const lng = callback.results[0].geometry.location.lng()
      this.map = [lat, lng]
    }
  },
}
</script>

<template>
  <Layout :class="$style.page">
    <BaseSteps :active="activeStep" :list="stepList" />
    <el-card shadow="never" :class="$style['card-wrapper']">
      <keep-alive>
        <component :is="stepComponent[`step${activeStep}`]" ref="step" :item-type="productType"
          :default-value="formDataAll" @validate="handleFormValidate"></component>
      </keep-alive>
    </el-card>
    <div :class="$style.footer">
      <el-button v-if="activeStep === 1" class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。"
        @click="onClickLeave">離開</el-button>
      <el-button v-if="activeStep !== 1" class="is-round" @click="activeStep--">上一步</el-button>
      <el-button v-if="activeStep !== stepList.length ? true : nextStepButtonVisible"
        data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步" type="primary" :loading="tryingNextStep" class="is-round"
        @click="onClickNextStep" :class="[$style.buttonBg]">{{ activeStep !== stepList.length ? '下一步' : '儲存'
        }}</el-button>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.buttonBg {
  &:focus {
    background-color: $color-primary;
    border: 1px solid $color-primary;
  }
}
</style>
